import { render } from "./CommentSection.vue?vue&type=template&id=265746a2"
import script from "./CommentSection.vue?vue&type=script&lang=js"
export * from "./CommentSection.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./CommentSection.vue?vue&type=style&index=0&id=265746a2&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__